module.exports = __webpack_public_path__ + "img/company.60dfa53b.png";